import React, { useState } from "react";
import { Button, Col, Icon, Input, InputNumber, message, Row } from "antd";
import Editor from "../../../../../components/Editor";
import style from "./style.module.scss";
import { OptionIsRight, TopicType } from "../../../../../service/homework";
import { saveExamTopic } from "../../../../../service/exam";
import { errorMessage, QuestionType } from "../../../../../service/service";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

interface ThesisFormProps {
    paperId: string;
    lockEdit: boolean;
    topic: TopicType | EmptyValue;
    updateData: () => void;
}

export default function ThesisForm({
    topic,
    paperId,
    lockEdit,
    updateData
}: ThesisFormProps) {
    const { examId } = useParams<{ examId: string; readonly: string }>();
    const history = useHistory();
    const [topicId, setTopicId] = useState(topic ? topic.topicId : "");
    const [trunk, setTrunk] = useState(topic ? topic.trunk : "");
    const [contentText, setContentText] = useState(
        topic ? topic.contentText : ""
    );
    const [score, setScore] = useState(topic ? topic.score : 0);

    const onSave = usePromiseCallback(async () => {
        if (trunk.trim().length === 0) {
            message.error("请填写论文题目");
            return;
        }

        if (contentText.trim().length === 0) {
            message.error("请填写论文要求");
            return;
        }

        if (score === 0) {
            message.error("请填写分数");
            return;
        }

        const topic: TopicType = {
            topicId,
            score,
            answers: [{ content: "", isRight: OptionIsRight.Right }],
            contentText,
            trunk,
            tempTopicId: "",
            topicType: QuestionType.ZhuGuan,
            topics: []
        };

        try {
            const newTopicId = await saveExamTopic(
                topicId,
                trunk,
                QuestionType.ZhuGuan,
                topic,
                examId,
                paperId
            );
            await updateData();
            setTopicId(newTopicId);
            message.info("保存成功");
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    return (
        <div>
            <Row className={`${style.padding} ${style.content}`}>
                <Col span={2} className={style.label}>
                    题目：
                </Col>

                <Col span={20}>
                    <Input
                        placeholder="填写题干"
                        size="large"
                        value={trunk}
                        onChange={e => setTrunk(e.target.value)}
                    />
                </Col>
            </Row>

            <Row className={`${style.padding}`}>
                <Col span={2} className={style.label}>
                    要求：
                </Col>

                <Col span={20}>
                    <Editor data={contentText} onChange={setContentText} />
                </Col>
            </Row>

            <Row className={`${style.padding} ${style.score}`}>
                <Col span={2} className={style.label}>
                    分值：
                </Col>
                <Col span={3}>
                    <InputNumber
                        min={0}
                        max={100}
                        placeholder="分数"
                        value={score}
                        onChange={val => setScore(val || 0)}
                        precision={1}
                    />
                </Col>
            </Row>

            <Row className={style.buttons}>
                {!lockEdit && (
                    <Button
                        type="primary"
                        size={"large"}
                        disabled={false}
                        onClick={onSave}>
                        <Icon type="cloud-upload" /> 保存
                    </Button>
                )}
                <Button size={"large"} onClick={() => history.goBack()}>
                    返回
                </Button>
            </Row>
        </div>
    );
}
